var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgX(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28.801,
    height: 28.268,
    viewBox: "0 0 28.801 28.268",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_17226",
    "data-name": "Group 17226",
    transform: "translate(-617.773 0.25)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "logo",
    d: "M16.525,11.758,26.863,0h-2.45L15.437,10.209,8.268,0H0L10.841,15.438,0,27.768H2.45l9.479-10.781L19.5,27.768h8.268L16.525,11.758ZM13.17,15.574l-1.1-1.537L3.332,1.8H7.095l7.053,9.872,1.1,1.537,9.168,12.832H20.652L13.17,15.574Z",
    transform: "translate(618.325)",
    fill: "#191919",
    stroke: "#191919",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_30940",
    "data-name": "Path 30940",
    d: "M-1176.245,13211.513h5.39l18.015,25.259h-6.063Z",
    transform: "translate(1796.752 -13210.259)",
    fill: "#191919",
    stroke: "#191919",
    strokeWidth: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgX);
export default __webpack_public_path__ + "static/media/x.adf186267f126372d712aa0359653263.svg";
export { ForwardRef as ReactComponent };